<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12" class="mt-1">
        <div class="dispatch-list row">
          <b-button variant="none" @click="back">
            <i class="fa fa-chevron-left"></i> Back
          </b-button>
        </div>
        <b-card :header="appendtext +' Category Setup'">
          <b-alert :show="isShowAlert" variant="success" isShowAlert="false">
            <p>
              {{appendtext}} Save Complete
              <b-button v-show="buttonishow" size="sm" variant="primary" @click="reload">
                <i class="fa fa-plus-circle"></i>&nbsp;Category
              </b-button>
            </p>
          </b-alert>

          <b-form @submit="onSubmit" v-if="!isShowAlert">
            <b-alert :show="errors.length > 0" variant="danger">
              <h6 class="alert-heading">Please fill in all required field!</h6>
              <ul>
                <li v-for="(error,i) in errors" :key="`error-${i}`">{{ error }}</li>
              </ul>
            </b-alert>

            <b-form-group id="exampleInputGroup2" label="Category Code*" label-for="exampleInput2">
              <b-form-input
                id="exampleInput2"
                type="text"
                v-model.trim="form.categorycode"
                placeholder="Category Code"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <label for="remarks">Category Name*</label>
              <b-form-input
                type="text"
                id="remarks"
                v-model.trim="form.categoryname"
                placeholder="Category Name"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="exampleInputGroup1" label="Checklist*">
              <input
                type="text"
                class="form-control bg-white"
                readonly
                v-model="ChecklistDescription"

                @click="GetChecklistID"
              />

            </b-form-group>
            <div class="dispatch-table">
              <b-button type="submit" variant="primary">
                <i class="fa fa-save"></i>
                {{appendtext}}
              </b-button>
            </div>
            <div class="dispatch-list">
              <b-button type="submit" variant="primary" class="btn btn-primary btn-sm btn-block">
                <i class="fa fa-save"></i>
                {{appendtext}}
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-modal v-model="ChecklistidModal" title="Select Checklist" ok-title="Save">
      <input type="Text" placeholder="Search" v-model="Searchchecklistid" class="form-control mb-2" />
      <span v-if="filterchecklistid.length == 0">No available Checklist.</span>
      <form class="form">
        <div style="height:50vh; overflow-x:auto;">
          <b-list-group>
            <b-list-group-item v-for="(item,index) in filterchecklistid" :key="index">
              <b-form-radio
                v-model="ChecklistModel"
                name="some-radios"
                :value="item"
                @change="onSelectChecklist"
              >{{item.checklistdescription}}</b-form-radio>
            </b-list-group-item>
          </b-list-group>
        </div>
      </form>
    </b-modal>
    <!-- <pre>{{$data|JSON}}</pre> -->
  </div>
</template>

<script>
import api from "../../services/api";

export default {
  data() {
    return {
      checklistIdoptions: [],
      ChecklistidModal: false,
      ChecklistDescription: "",
      Searchchecklistid: "",
      errors: [],
      isShowAlert: false,
      isDisabled: this.$route.params.checklistId == undefined ? false : true,
      appendtext: this.$route.params.id == undefined ? "Create" : "Update",
      buttonishow: this.$route.params.id == undefined ? true : false,
      checked: true,
      groupId:"",
      form: {
        id: this.$route.params.id == undefined ? "" : this.$route.params.id,
        checklistid: "",
        categorycode: "",
        categoryname: "",
        brancode: this.$store.getters.selectedWarehouse,

        createdby:
          this.$store.getters.user.firstname +
          " " +
          this.$store.getters.user.lastname,
        createddate: ""
      }
    };
  },
  computed: {
    filterchecklistid: function() {
      var self = this;
      return self.checklistIdoptions.filter(function(cust) {
        return (
          cust.checklistdescription
            .toLowerCase()
            .indexOf(self.Searchchecklistid.toLowerCase()) >= 0
        );
      });
    }
  },
  methods: {
    checkForm: function() {
      if (
        this.form.categorycode &&
        this.form.categoryname &&
        this.form.checklistid
      ) {
        return true;
      } else {
        this.errors = [];

        if (!this.form.categorycode) {
          this.errors.push("Category Code required.");
        }

        if (!this.form.categoryname) {
          this.errors.push("Category Name required.");
        }
        if (!this.form.checklistid) {
          this.errors.push("Checklis required.");
        }

        return false;
      }
    },
    onSubmit: function(evt) {
      evt.preventDefault();
      if (this.checkForm() == false) {
        return;
      }
      this.$store.commit("setLoading", true);
      if (this.appendtext == "Create") {
        api.instance
          .post("itsek/add-category", this.form)
          .then(() => {
            this.isShowAlert = true;
            this.$store.commit("setLoading", false);
          })
          .catch(function(err) {
            api.httpMsg(this, err.status, err.data);
            this.$store.commit("setLoading", false);
          });
      } else if (this.appendtext == "Update") {
        api.instance
          .put("itsek/modify-category", this.form)
          .then(() => {
            this.isShowAlert = true;
            this.$store.commit("setLoading", false);
          })
          .catch(function(err) {
            api.httpMsg(this, err.status, err.data);
            this.$store.commit("setLoading", false);
          });
      }
    },
    GetChecklistID: function() {
      let self = this;
      if (self.$route.params.checklistId != undefined) {
      self.$store.commit("setLoading", true);
      self.checklistIdoptions = [];
      api.instance
        .get(
          "itsek/get-chechlistID-by-department?department=" +
            self.$store.getters.warehousecode +
            "&groupId=" + self.groupId
        )
        .then(function(resp) {
          resp.data.forEach(element => {
            self.checklistIdoptions.push({
              checklistId: element.checklistId,
              checklistdescription: element.checklistdescription
            });
          });
          self.ChecklistidModal = true;
          self.$store.commit("setLoading", false);
        })
        .catch(function(err) {
          api.httpMsg(self, err.status, err.data);
          self.$store.commit("setLoading", false);
        });
      }
      // if (self.$route.params.checklistId == ""){
      else
      {
      self.$store.commit("setLoading", true);
      self.checklistIdoptions = [];
      api.instance
        .get(
          "itsek/get-chechlist-by-department?department=" +
            self.$store.getters.warehousecode

        )
        .then(function(resp) {
          resp.data.forEach(element => {
            self.checklistIdoptions.push({
              checklistId: element.checklistId,
              checklistdescription: element.checklistdescription
            });
          });
          self.ChecklistidModal = true;
          self.$store.commit("setLoading", false);
        })
        .catch(function(err) {
          api.httpMsg(self, err.status, err.data);
          self.$store.commit("setLoading", false);
        });
        }
      // }
    },
    onSelectChecklist: function(val) {
      let self = this;
      self.form.checklistid = val.checklistId;
      self.ChecklistDescription = val.checklistdescription;
    },
    back: function() {
      this.$router.push("/Maintenance/636984307928200838");
    },
    reload: function() {
      this.$router.go(this.$router.currentRoute);
    },
    getData: function() {
      let self = this;
      if (this.$route.params.id !== undefined) {
        self.$store.commit("setLoading", true);
        api.instance
          .get(
            "itsek/get-category-byid?id=" +
              self.$route.params.id +
              "&brancode=" +
              self.form.brancode
          )
          .then(resp => {
            self.form = resp.data;
            self.ChecklistDescription = resp.data.checklistdescr;
            if (self.form.isactive === 1) {
              self.checked = true;
            } else {
              self.checked = false;
            }
            self.$store.commit("setLoading", false);
          })
          .catch(err => {
            self.$store.commit("setLoading", false);
            api.httpMsg(self, err.status, err.data);
          });
      }
    },
      getCategoryId: function() {
      let self = this;
      if (self.$route.params.checklistId !== undefined) {
        self.$store.commit("setLoading", true);
        api.instance
          .get("itsek/select-itsekcheckby-id?checklistId=" + self.$route.params.checklistId)
          .then(resp => {
            self.form.checklistid = resp.data.checklistId;

            self.groupId = resp.data.groupId;
            self.$store.commit("setLoading", false);
          })
          .catch(err => {
            self.$store.commit("setLoading", false);
            api.httpMsg(self, err.status, err.data);
          });
      }
    }
  },
  watch: {
    selectdepartment: function(param) {
      //select groupcode
      this.form.department = param.department;
    },
    checked: function(val) {
      if (val) {
        this.form.isactive = 1;
      } else {
        this.form.isactive = 0;
      }
    }
  },
  created: function() {
    this.getData();
    this.getCategoryId();
  }
};
</script>
